var map = {
	"./1.jpg": 1459,
	"./10.jpg": 8491,
	"./11.jpg": 2654,
	"./12.jpg": 1321,
	"./13.jpg": 3324,
	"./14.jpg": 7735,
	"./15.jpg": 5578,
	"./2.jpg": 1412,
	"./3.jpg": 9457,
	"./4.jpg": 7762,
	"./5.jpg": 4143,
	"./6.jpg": 1152,
	"./7.jpg": 6717,
	"./8.jpg": 8974,
	"./9.jpg": 283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;